// ACTION TYPES

export const USER_LIST = 'SMK_ADMIN/USER_LIST';
export const USER_SEARCH = 'SMK_ADMIN/USER_SEARCH';
export const USER_PROFILE = 'SMK_ADMIN/USER_PROFILE';
